import './CreateTicketButton.scss';
import { Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';



/**
 * CreateTicketButton Component
 *
 * @component
 * @description
 * A button that triggers the "Create Ticket" flow. When clicked, it calls the 'onOpen' callback
 * provided by the parent component to open a ticket creation popup
 *
 * @param {Object} props - Component props.
 * @param {function} props.onOpen - Callback function to open the create ticket popup.
 *
 * @returns {JSX.Element} A Material-UI button labeled "New Ticket".
 *
 * @example
 * // Usage:
 * <CreateTicketButton  onOpen={handleOpenPopup} />
 */


export default function CreateTicketButton({onOpen}) {

  function handleClick() {
    onOpen();
  }

  return (
    <div>
      <Tooltip title="Create a New Ticket" placement="left" arrow enterDelay={500} enterNextDelay={500} data-testid="create-ticket-tooltip">
        <Button
        id="CreateTicketButton" 
        data-testid="create-ticket-button" 
        variant="contained" 
        size="large" 
        onClick={handleClick}>
        New Ticket
        </Button>
      </Tooltip>
    </div>

  );
}